export const URLConfiguration = {
  paths: {
    simulacionProductosRentas: {
      parametros:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/parametros-simulacion',
      createSimulacion:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/personas-naturales/consultar',
      createPersona:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/personas-naturales/validar',
      actualizaInformacion:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/simulaciones-rentas/{idSimulacion}/actualizar-informacion',
      confirmaInformacion:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/simulaciones-rentas/{idSimulacion}/confirmar-informacion',
      cotizacion:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/simulaciones-rentas/{idSimulacion}/cotizaciones',
      cotizacionEnviar:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/simulaciones-rentas/{idSimulacion}/cotizaciones/{idCotizacion}/enviar',
      captcha:
        '/sprp/ux-ma-sprp-simulacion-productos-rentas/v1/soporte/captcha',
    },
    token: '/pga-tokens/soporte-ti/v2/tokens',
  },
};
